import { render, staticRenderFns } from "./PureActivityBoardItem.vue?vue&type=template&id=179ca908"
import script from "./PureActivityBoardItem.vue?vue&type=script&lang=js"
export * from "./PureActivityBoardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports